import {
    ADSENSE
} from "../../constants/ActionTypes";

export const adsense = (adsenseData) => {
    return {
        type: ADSENSE,
        payload: adsenseData
    }
}
